import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
import { ECLService } from '@lmc-app/core/services/ecl.service';

interface LoanGroupTransfer {
	loan_group_desc: string;
	interest_balance: number;
	transfer_date: string;
}

@Component({
	selector: 'app-loan-group-transfer-accrued',
	templateUrl: './loan-group-transfer-accrued.component.html',
	styleUrls: ['./loan-group-transfer-accrued.component.scss'],
})
export class LoanGroupTransferAccruedComponent implements OnInit, OnDestroy {
	private parentSub = new Subscription();
	private readonly _onDestroy = new Subject<void>();

	protected isLoading: boolean = false;
	protected readonly inputDateForm = new FormGroup({
		input_date: new FormControl(null),
	});

	protected completeMft: number = 0;
	protected interestEcl: number = 0;
	protected transfers: LoanGroupTransfer[] = [];
	protected removedAmount: number = 0;
	protected netAccrualForThisMonth: number = 0;
	protected net: number = 0;

	protected readonly title: string = "Loan Group Transfer Accrued";

	public constructor(
		private eclService: ECLService,
		protected readonly currencyFormatter: CurrencyPipe,
	) { }

	public ngOnInit(): void {
		this.inputDateForm.controls.input_date.setValue(new Date("2026-01-01"));
	}

	public ngOnDestroy(): void {
		this.parentSub.unsubscribe();
		this._onDestroy.next();
		this._onDestroy.complete();
	}

	protected getBalance() {
		const inputDate = this.inputDateForm.controls.input_date.value.toISOString().substring(0, 10);
		this.isLoading = true;
		this.parentSub.add(this.eclService.getLoanGroupTransferAccrued(inputDate).subscribe({
			next: (res: any) => {
				this.isLoading = false;
				if (res) {
					this.completeMft = res.completeMft;
					this.interestEcl = res.interestEcl;
					this.transfers = res.transfers;
					this.removedAmount = res.removedAmount;
					this.netAccrualForThisMonth = res.netAccrualForThisMonth;
					this.net = res.net;
				}
			},
			error: () => this.isLoading = false,
		}));
	}
}
